import { ForgetPage } from './forget.component';
import { connect } from 'react-redux';
import { forgotPassword } from "./../../api/user/userAction";

const mapDispatchToProps = {
    forgotPassword
};

const mapStateToProps = state => ({
    isSent: state.userPage.isSent,
    isLoading: state.userPage.isLoading,
});

export const ForgetContainer = connect(mapStateToProps, mapDispatchToProps)(ForgetPage);